const roundNumberFormatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 0,
});

export default roundNumberFormatter; 